
import { DealsProviderService } from './provider/dealslistprovider';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { DnrsavingsComponent } from './dnrsavings';
import { ParenttabsPage } from './pages/parenttabs/parenttabs';
import { ChildtabsPage } from './pages/childtabs/childtabs';
import { TabPage } from './pages/tabpage/tabpage';
import { SearchPage } from './pages/search/search';
import { SearchTabs } from './pages/search/searchtabs/searchtabs';
import { SavingsProfilePage } from './pages/search/savingsprofile/savingsprofile';
import { SearchTabPage } from './pages/search/searchtabpage/searchtabpage';
import { SearchDisplayCheck } from './provider/searchVisibility';
import { HTTP } from '@ionic-native/http';
import { ConfigurationManager } from './provider/ConfigurationManager';
import { CategoryProviderService } from './provider/category.provider';
import { CategoryPage } from './pages/category/category';
import { DestinationsPage } from './pages/destinations/destinations';
import { DealDetailsPage } from './pages/dealdetails/dealdetails';
import { Redeem } from './pages/dealdetails/redeem/redeem';
import { DealsDetailsProviderService } from './provider/dealsdetailsprovider';
import { IonicModule } from 'ionic-angular';
import { TabsProviderService } from './provider/tabsprovider';
import { FavouritePartnerService } from './provider/favpartnerlist';
import { ToggleFavouriteService } from './provider/togglefavourite';
import { DestinationsProviderService } from './provider/destinations.provider';
import { SearchResultsService } from './provider/searchresults';
import { SearchResultsPage } from './pages/search/searchresults/searchresults';
import { ToggleBlockPartnerService } from './provider/toggleblockpartner';
import { ToggleThumbsUpDownService } from './provider/togglethumbsdeal';
import { TempTokenService } from './provider/temptokenservice';
import { CustomSuperTabsModule } from './customviews/customchildtabs/customsupertabmodule';
import { ParentCustomSuperTabsModule } from './customviews/customparenttabs/parentcustomsupertabmodule';
import { CustomSuperTabsController } from './customviews/customchildtabs/customsupertabscontroller';
import { ParentCustomSuperTabsController } from './customviews/customparenttabs/parentcustomsupertabscontroller';
import { Geolocation } from '@ionic-native/geolocation';
import { HttpClientAdapterInitializer, HttpClientService } from './http/http-client.service';
import { NetworkMonitorService } from './http/network-monitor.service';
import { HttpClientAdapter } from './http/http-client-adapter';
import { AngularHttpClient, HttpErrorNotificationService, HttpErrorServiceInitializer, IonicHttpClient } from './http';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  declarations: [
    DnrsavingsComponent,
    ParenttabsPage,
    ChildtabsPage,
    TabPage,
    SearchPage,
    SearchTabs,
    SearchTabPage,
    SavingsProfilePage,
    CategoryPage,
    DestinationsPage,
    DealDetailsPage,
    Redeem,
    SearchResultsPage
  ],
  imports: [
    IonicModule,
    CustomSuperTabsModule,
    ParentCustomSuperTabsModule,
    HttpClientModule
  ],
  exports: [
    DnrsavingsComponent,
    DealDetailsPage
  ],
  entryComponents: [
    ChildtabsPage,
    TabPage,
    SearchPage,
    SearchTabPage,
    SavingsProfilePage,
    SearchTabs,
    ParenttabsPage,
    CategoryPage,
    DestinationsPage,
    DealDetailsPage,
    Redeem,
    SearchResultsPage
  ],
  providers: [
    SearchDisplayCheck,
    CustomSuperTabsController,
    ParentCustomSuperTabsController,
    TabsProviderService,
    HTTP,
    ConfigurationManager,
    DealsProviderService,
    CategoryProviderService,
    DestinationsProviderService,
    ToggleFavouriteService,
    DealsDetailsProviderService,
    FavouritePartnerService,
    SearchResultsService,
    ToggleBlockPartnerService,
    ToggleThumbsUpDownService,
    TempTokenService,
    Geolocation,
    AngularHttpClient,
    IonicHttpClient,
    HttpClientService,
    NetworkMonitorService,
    HttpClientAdapterInitializer,
    HttpErrorServiceInitializer,
    HttpErrorNotificationService,
  ]
})
export class SavingsModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: SavingsModule
	  };
  }
}